import m from 'mithril'
import { initMithrilComponent } from '@client-shared/utils/mithril'
import RadialProgress from '@client-shared/components-v2/radial-progress'
import ReportsProgressEmitter from '../../reports-progress-emitter'
import type { ReportProgressHandler } from '../../reports-progress-emitter'

import s from './reports-menu-link-progress.module.scss'

interface Attrs extends m.Attributes {}

interface State {
	running_reports_count: number
	progress_percentage: number
	handleReportsProgress: ReportProgressHandler
}

const ReportsMenuLinkProgress = initMithrilComponent<Attrs, State>()

ReportsMenuLinkProgress.oninit = (vnode) => {
	vnode.state.running_reports_count = ReportsProgressEmitter.running_reports_count
	vnode.state.progress_percentage = ReportsProgressEmitter.cumulative_progress

	vnode.state.handleReportsProgress = () => {
		vnode.state.running_reports_count = ReportsProgressEmitter.running_reports_count
		vnode.state.progress_percentage = ReportsProgressEmitter.cumulative_progress
	}
}

ReportsMenuLinkProgress.oncreate = (vnode) => {
	ReportsProgressEmitter.subscribe(vnode.state.handleReportsProgress)
}

ReportsMenuLinkProgress.onremove = (vnode) => {
	ReportsProgressEmitter.unsubscribe(vnode.state.handleReportsProgress)
}

ReportsMenuLinkProgress.view = (vnode) => {
	return m('span', { class: s.reports_menu_link_progress }, [
		m('span', vnode.children),
		vnode.state.running_reports_count > 0 &&
			m(
				RadialProgress,
				{ class: s.radial_progress, progress_percentage: vnode.state.progress_percentage },
				vnode.state.running_reports_count > 9 ? '9+' : vnode.state.running_reports_count,
			),
	])
}

export default ReportsMenuLinkProgress
